export const SET_PROMOTIONS = 'SET_PROMOTIONS';
export const GET_PROMOTIONS_REQUEST = 'GET_PROMOTIONS_REQUEST';

export const getPromotionsRequest = (onComplete) => ({
  type: GET_PROMOTIONS_REQUEST,
  onComplete
});
